import type { CommandServices } from '@wix/cli-command-contract';
import { createCommand } from '@commander-js/extra-typings';
import { domain } from './domain.js';

export const account = (
  services: CommandServices,
  cliVersion: string,
  configSiteId?: string
) => {
  const command = createCommand('account')
    .description('Manage your Wix account')
    .option(
      '--site-id <siteId>',
      'Site ID to scope account commands to a specific site'
    );

  command.hook('preAction', async () => {
    const { isLoggedInToAccount } = await import('@wix/cli-auth');
    const { CliError, CliErrorCode } = await import('@wix/cli-error');

    if (!(await isLoggedInToAccount())) {
      throw new CliError({ cause: null, code: CliErrorCode.LoginRequired() });
    }
  });

  command.addCommand(domain(services, cliVersion, configSiteId));

  return command;
};
